import type { ReactNode } from 'react';
import { Modal } from './Modal';
import { Button } from './Button';
import styles from './Dialog.module.css';

export type DialogProps = {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  /** CEVRILMIS baslik ve metin — bilesen i18n'e bagli degil. */
  title: ReactNode;
  description?: ReactNode;
  confirmLabel: string;
  cancelLabel: string;
  /** Geri alinamayan islemler (hesap silme, uye cikarma) icin 'danger'. */
  tone?: 'primary' | 'danger';
  /** Onay istegi surerken butonu kilitler. */
  busy?: boolean;
};

/** Tek soruluk onay kutusu. Karmasik icerik gerekiyorsa Modal kullanilir. */
export function Dialog({
  open,
  onCancel,
  onConfirm,
  title,
  description,
  confirmLabel,
  cancelLabel,
  tone = 'primary',
  busy = false,
}: DialogProps) {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={title}
      width="sm"
      dismissOnScrim={!busy}
      footer={
        <>
          <Button tone="ghost" onClick={onCancel} disabled={busy}>
            {cancelLabel}
          </Button>
          <Button tone={tone} onClick={onConfirm} loading={busy}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      {description ? <p className={styles.description}>{description}</p> : null}
    </Modal>
  );
}
